import {
  PRICE_POLICIES_ADD_BONIFICATIONS_BEGIN,
  PRICE_POLICIES_ADD_BONIFICATIONS_SUCCESS,
  PRICE_POLICIES_ADD_BONIFICATIONS_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case PRICE_POLICIES_ADD_BONIFICATIONS_BEGIN:
      return {
        ...state,
        bonificationsPending: true,
        bonificationsError: false
      }
    case PRICE_POLICIES_ADD_BONIFICATIONS_SUCCESS:
      return {
        ...state,
        bonificationsPending: true,
        bonificationsError: false,
        bonificationsSuccess: action.data.bonificationsSuccess
      }
    case PRICE_POLICIES_ADD_BONIFICATIONS_FAILURE:
      return {
        ...state,
        bonificationsPending: true,
        bonificationsError: action.data.bonificationsError
      }
    default:
      return state
  }
}
